var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-10 px-2 cursor-pointer hover:bg-base-20 whitespace-nowrap",class:{
    'flex items-center': _vm.middle,
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }